import { PermDeviceInformation } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Alert, Button, ButtonGroup, Grid, Input, Option, Select, Stack, Typography } from "@mui/joy";
import { useState } from "react";
import { server_url } from '../core/config_geral'
import { Link } from "react-router-dom";
import axios from "axios";


function AdicionarMediaPage() {

    var token = useSelector((state) => state.auth.token)
    const [state, setState] = useState({
        loading: false,
        information: "Enviar",
        error: null,
        descricao: null,
        tipo: null,
        file: null,
    })

    function updateAttribute(tag, valor) {
        setState(prev => ({
            ...prev,
            [tag]: valor
        }))
    }

    const registrarMedia = async (tmpId, descricao, tipo) => {
        const formData = new FormData();
        const formToSend = {
            action: "CASTOR_ADICIONAR_NOVA_MEDIA_RPC",
            runNow: true,
            payload: JSON.stringify({
                descricao: descricao,
                tipo: tipo,
                arquivoTmpId: tmpId
            }),
        };

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(server_url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                },
                onUploadProgress: (progressEvent) => {

                },
            });

            return r;
        } catch (error) {
            console.log(error)
            return null;
        }
    }

    const registrarArquivoTemporario = async (file) => {
        const formData = new FormData();
        const formToSend = {
            action: "STG_NOVO_ARQUIVO_TEMPORARIO_RPC",
            runNow: true,
            payload: "",
        };

        var filename = file.name

        formData.append("file", file);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(server_url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                },
                onUploadProgress: (progressEvent) => {
                    console.log(progressEvent.progress)
                    setState(prev => ({
                    ...prev,
                    information: "Enviando... "+(progressEvent.progress*100).toFixed(0)+ "%",
                }))
                },
            });

            return r.data.payload;
        } catch (error) {
            console.log(error)
            return null;
        }
    }

    async function enviar() {


        setState(prev => ({
            ...prev,
            error: null,
            information: "Enviando...",
            loading: true
        }))

        var error = null;
        if (state.descricao == null || state.descricao.length == 0)
            error = "Descrição inválida";
        else if (state.tipo !== "IMAGEM" && state.tipo !== "VIDEO")
            error = "Tipo inválido";
        else if (state.file == null)
            error = "File inválido"

        if (error != null)
            setState(prev => ({ ...prev, error, loading: false, information: "Enviar" }))
        else {
            setState(prev => ({ ...prev, information: "Enviando TMP..." }))
            var id = await registrarArquivoTemporario(state.file)
            setState(prev => ({ ...prev, information: "Registrando media..." }))

            setTimeout(() => {
                if (id == null) {
                    setState(prev => ({ ...prev, error: "Erro ao enviar arquivo temporario. (Vide console)", loading: false, information: "Enviar" }))
                } else {
                    var r = registrarMedia(id, state.descricao, state.tipo)

                    setTimeout(() => {
                    if (r == null)
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviar",
                            error: "Erro ao registrar media, apos tmp file (Vide Console)",
                        }))
                    else
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviado!",
                            error: "SUCESSO!",
                        }))
                    }, 500);
                }
            }, 100)


        }
    }

    return <>
        <Grid xs={12}>
            <Stack spacing={1}>
                <Typography>
                    Cadastro de media
                </Typography>
                {state.error !== null && <Alert color="danger"> {state.error}</Alert>}
                <Input
                    disabled={state.loading}
                    placeholder="Descrição"
                    onChange={(e) => {
                        updateAttribute("descricao", e.target.value)
                    }}></Input>
                <Select
                    disabled={state.loading}
                    placeholder="Selecione o tipo"
                    onChange={(e, value) => {
                        updateAttribute("tipo", value)
                    }}>
                    <Option value="IMAGEM">Imagem</Option>
                    <Option value="VIDEO">Video</Option>
                </Select>
                <Input disabled={state.loading} placeholder="Selecione o arquivo" name="file" type="file" onChange={(e) => updateAttribute("file", e.target.files[0])} />
                <Button onClick={enviar} disabled={state.loading}>{state.information}</Button>
            </Stack>
        </Grid>
    </>
}

export default AdicionarMediaPage